import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/AddProduct.css";

function ManageRep() {
  const [NameEN, setNameEN] = useState("");
  const [NameAR, setNameAR] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [Image, setImage] = useState("");
  const [AreaAR, setAreaAR] = useState("");
  const [AreaEN, setAreaEN] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [editingRepId, setEditingRepId] = useState(null);

  const [RepsList, setRepsList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const handleEdit = async (Rep) => {
    setEditingRepId(Rep._id);
    setNameEN(Rep.NameEN);
    setNameAR(Rep.NameAR);
    setAreaEN(Rep.AreaEN);
    setAreaAR(Rep.AreaAR);
    setEmail(Rep.email);
    setPassword(Rep.password);
    setImage(Rep.Image || "");
  };
  const handleDelete = async (Rep) => {
    const response = await fetch(
      `https://cairomed-backend.vercel.app/api/representatives/deleteRepresentative/${Rep._id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json", // Set content type to JSON
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to Delete Rep");
    }
    getRepList();
    alert("Rep Deleted successfully!");
  };
  const handleCreateRep = async (repData) => {
    // Log the JSON data being sent
    console.log("=== Representative JSON being sent to API ===");
    console.log(repData);
    
    try {
      const response = await fetch(
        "https://cairomed-backend.vercel.app/api/representatives/createRepresentative",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(repData),
        }
      );
      
      console.log("API Create Response Status:", response.status);
      
      const responseData = await response.json();
      console.log("API Response Data:", responseData);
      
      if (!response.ok) {
        throw new Error(responseData.message || "Failed to create Rep");
      }
      
      alert("Rep created successfully!");
      return responseData;
    } catch (error) {
      console.error("Error response:", error);
      alert(`An error occurred: ${error.message}`);
      throw error;
    }
  };
  
  const handleUpdateRep = async (formData) => {
    const bodyData = {
      NameEN: formData.get("NameEN"),
      NameAR: formData.get("NameAR"),
      AreaAR: formData.get("AreaAR"),
      AreaEN: formData.get("AreaEN"),
      email: formData.get("email"),
      password: formData.get("password"),
      PhoneNumber: formData.get("PhoneNumber"),
      Image: formData.get("Image"),
    };
    
    console.log("=== Update Representative Data ===");
    console.log("Data being sent for update:", bodyData);

    const response = await fetch(
      `https://cairomed-backend.vercel.app/api/representatives/updateRepresentative/${editingRepId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json", // Set content type to JSON
        },
        body: JSON.stringify(bodyData), // Send as JSON
      }
    );
    
    console.log("API Update Response:", response);

    if (!response.ok) {
      const errorData = await response.json();
      console.log("Error response:", errorData);
      throw new Error(errorData.message || "Failed to update Rep");
    }

    alert("Rep updated successfully!");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      console.log("=== Representative Form Submission Data ===");
      console.log("NameEN:", NameEN);
      console.log("NameAR:", NameAR);
      console.log("AreaEN:", AreaEN);
      console.log("AreaAR:", AreaAR);
      console.log("PhoneNumber:", PhoneNumber);
      console.log("Email:", email);
      console.log("Password:", password ? "******" : "(empty)");
      console.log("Image URL:", Image);
      
      if (editingRepId) {
        // For update, keep using FormData for now
        const formData = new FormData();
        formData.append("NameEN", NameEN);
        formData.append("NameAR", NameAR);
        formData.append("AreaAR", AreaAR);
        formData.append("AreaEN", AreaEN);
        formData.append("PhoneNumber", PhoneNumber);
        formData.append("password", password);
        formData.append("email", email);
        formData.append("Image", Image);
        
        await handleUpdateRep(formData);
      } else {
        // For create, use JSON directly
        const jsonData = {
          NameEN,
          NameAR,
          AreaAR,
          AreaEN,
          PhoneNumber,
          password,
          email,
          Image
        };
        
        await handleCreateRep(jsonData);
      }

      setNameEN("");
      setNameAR("");
      setImage("");
      setAreaAR("");
      setAreaEN("");
      setPassword("");
      setEmail("");
      setEditingRepId(null);

      getRepList();
    } catch (error) {
      console.error("Error:", error);
      alert(`An error occurred: ${error.message}`);
    }
  };

  useEffect(() => {
    getRepList();
  }, []);

  async function getRepList() {
    try {
      const response = await fetch(
        "https://cairomed-backend.vercel.app/api/representatives/getRepresentatives"
      );
      if (!response.ok) {
        throw new Error("Failed to fetch Reps data");
      }
      const filteredData = await response.json();
      setRepsList(filteredData);
      console.log(filteredData);
    } catch (error) {
      console.error("Error fetching Reps:", error);
    }
  }

  const filteredReps = RepsList.filter((Rep) =>
    `${Rep.NameEN} ${Rep.NameAR}`
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <section>
        <div className="container mt-5 addRepContainer d-flex flex-column w-100 align-items-start justify-content-start">
          <h2>Manage Representative</h2>
          <form
            onSubmit={handleSubmit}
            className="row w-100 px-0 g-4 pt-3 pb-5"
          >
            <div className="col-lg-6 col-12 d-flex flex-column gap-2">
              <label htmlFor="NameEN">Representative Name:</label>
              <input
                type="text"
                id="NameEN"
                value={NameEN}
                onChange={(e) => setNameEN(e.target.value)}
              />
            </div>
            <div className="col-lg-6 col-12 d-flex flex-column gap-2">
              <label htmlFor="NameAR" className="arabic-version">
                إسم المندوب:
              </label>
              <input
                type="text"
                id="NameAR"
                value={NameAR}
                onChange={(e) => setNameAR(e.target.value)}
              />
            </div>
            <div className="col-lg-6 col-12 d-flex flex-column gap-2">
              <label htmlFor="AreaEN">Region:</label>
              <input
                type="text"
                id="AreaEN"
                value={AreaEN}
                onChange={(e) => setAreaEN(e.target.value)}
              />
            </div>
            <div className="col-lg-6 col-12 d-flex flex-column gap-2">
              <label htmlFor="AreaAR" className="arabic-version">
                المنطقة:
              </label>
              <input
                type="text"
                id="AreaAR"
                value={AreaAR}
                onChange={(e) => setAreaAR(e.target.value)}
              />
            </div>
            <div className=" col-12 d-flex flex-column gap-2">
              <label htmlFor="AreaAR">Phone number :</label>
              <input
                type="text"
                id="PhoneNumber"
                value={PhoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </div>
            <div className=" col-12 d-flex flex-column gap-2">
              <label htmlFor="email">Email :</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className=" col-12 d-flex flex-column gap-2">
              <label htmlFor="password">password :</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="col-12 d-flex flex-column gap-2">
              <label htmlFor="Image">Image URL</label>
              <input
                type="url"
                id="Image"
                value={Image}
                onChange={(e) => setImage(e.target.value)}
                placeholder="Enter image URL"
              />
            </div>
            <div className="col-12 d-flex flex-row justify-content-between gap-2">
              <button type="submit" className="submit-btn">
                {editingRepId ? "Update Rep" : "Submit"}
              </button>
              <button type="button" className="cancel-btn">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </section>
      <section>
        <div className="container">
          <input
            className="search-input"
            type="text"
            placeholder="Search by name (EN/AR)"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <div className="table-wrapper">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Rep Name (EN)</th>
                  <th scope="col">Region</th>
                  <th scope="col">Edit</th>
                  <th scope="col">Delete</th>
                </tr>
              </thead>
              <tbody>
                {filteredReps.length > 0 ? (
                  filteredReps.map((Rep) => (
                    <tr key={Rep._id}>
                      <td>{Rep.NameEN}</td>
                      <td>{Rep.AreaEN}</td>
                      <td>
                        <button onClick={() => handleEdit(Rep)} className="table-edite-btn">Edit</button>
                      </td>
                      <td>
                        <button onClick={() => handleDelete(Rep)} className="table-delete-btn">
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">No Reps found...</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  );
}

export default ManageRep;
